import styled from "styled-components";

export const InfoContainer = styled.div`
    font-size: 16px;

    & > div > span:first-child:after {
        content: ": ";
    }
`;
